/**
 * Thousands grouping for an amount box's display text (ADR 076 — Money Input
 * Text). Display only: it adds commas and never changes the digits.
 */

/**
 * Group the whole part of a numeric string with thousands commas, leaving any
 * sign, point and fraction as they are ("12345.6" → "12,345.6", "7500." → "7,500.").
 *
 * @param numeric - Digits with at most one ".", as an amount box holds them.
 * @returns The grouped text, or "" for an empty string.
 */
export function groupThousands(numeric: string): string {
    if (!numeric) return '';
    const parts = numeric.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
}

/** Text a money box holds while typing: a plain decimal (sign, digits, one point). */
const TYPED_NUMERIC_RE = /^-?\d*\.?\d*$/;

/**
 * Group a money box's typed text for display. Text that is not a plain decimal
 * ("1e5", "50-20") is shown exactly as typed, so the schema's refusal reads
 * against what the person sees (ADR 076 — Money Input Text).
 *
 * @param text - The box's text with separators already removed.
 * @returns The text with thousands commas, or the text unchanged when it is not a plain decimal.
 */
export function groupTypedMoney(text: string): string {
    return TYPED_NUMERIC_RE.test(text) ? groupThousands(text) : text;
}
